import { formatDateWithClock } from '~/services/TimeService';

const dateFormatter = (date) => {
  if (date) {
    return formatDateWithClock(date);
  }

  return '';
};

export default dateFormatter;

/**
 * Ensures a date string has an ISO 8601 time component.
 * Appends `T00:00:00.000Z` to bare `YYYY-MM-DD` values.
 */
export function normalizeToISODate(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';
  return trimmed.includes('T') ? trimmed : `${trimmed}T00:00:00.000Z`;
}
